export { MinimalistFooter } from './MinimalistFooter'
